import styled from '@emotion/styled';
import { tokens, Field, Radio } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

interface PositionOption {
  value: string;
  label: string;
}

export interface SurveyPositionProps {
  showSurveyPosition: boolean;
  position: string;
  positionOptions?: PositionOption[];
  onPositionChange: (newValue: string) => void;
}

const DEFAULT_POSITION_OPTIONS = [
  { value: 'left', label: 'Left' },
  { value: 'right', label: 'Right' },
];

const Positions = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${tokens.spacer.x2pt5};
`;

const StyledRadio = styled(Radio)`
  margin-bottom: ${tokens.spacer.x1pt5};
`;

export function SurveyPosition({
  showSurveyPosition,
  position,
  positionOptions = DEFAULT_POSITION_OPTIONS,
  onPositionChange,
}: SurveyPositionProps): JSX.Element | null {
  const { t } = useTranslation('feedback', { keyPrefix: 'wizard.section.appearance.position' });
  return showSurveyPosition ? (
    <Field inputId="position-section" labelText={t('label')} helperText={t('helper-text')}>
      <Positions>
        {positionOptions.map(({ value }) => (
          <StyledRadio
            key={value}
            isChecked={value === position}
            labelContent={t(`option.${value}`)}
            onChange={() => onPositionChange(value)}
            value={value}
            name="position"
          />
        ))}
      </Positions>
    </Field>
  ) : null;
}
